import { DataGridContainer } from '../styles'
import { DashboardTicketSelector } from 'bd-web-components'
import { CourtesySectorProps } from '../../../../hooks/producer-pdv'
import { FlowButtonControl } from '../../../../components/FlowButtonControl'
import { CourtesyRequestInitialProps } from '../../../../utils/courtesy-request-utils'
import { FormikProps } from 'formik'

interface SectorSelectorComponentProps {
  sectors: CourtesySectorProps[] | null
  useFormikProps: FormikProps<CourtesyRequestInitialProps>
  handleButtonClick: () => void
  name: keyof CourtesyRequestInitialProps
}

export const SectorSelector = ({
  sectors,
  name,
  useFormikProps,
  handleButtonClick,
}: SectorSelectorComponentProps) => {
  const hasSector = useFormikProps.values[name] !== ''
  return (
    <>
      <DataGridContainer>
        {sectors !== null &&
          sectors.map((sector: CourtesySectorProps) => {
            const active = useFormikProps.values[name] === sector.sector_id
            return (
              <div style={{ marginBottom: '10px' }}>
                <DashboardTicketSelector
                  key={sector.sector_id}
                  title={sector.sector_name}
                  event={sector.event_name}
                  active={active}
                  onClick={() => {
                    useFormikProps.setFieldValue(name, sector.sector_id)
                  }}
                />
              </div>
            )
          })}
      </DataGridContainer>
      <FlowButtonControl
        rollback={undefined}
        flowControl={hasSector}
        action={handleButtonClick}
      />
    </>
  )
}
